// FLAGS: none
// The signed-in-but-not-permitted screen inside the shell: names the account and offers sign-out.
import { ShieldX } from "lucide-react";
import { useNavigate } from "react-router";
import { Button } from "@openup/shared/primitives/ui/button";
import { useLogoutMutation } from "@src/queries/auth";
import { UserProfile } from "@src/models/auth";

interface AccessDeniedProps {
  user: UserProfile;
}

const AccessDenied = ({ user }: AccessDeniedProps) => {
  const navigate = useNavigate();
  const logoutMutation = useLogoutMutation();

  const onSignOut = () => {
    logoutMutation.mutate(undefined, {
      onSettled: () => navigate("/login", { replace: true }),
    });
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <ShieldX className="h-12 w-12 text-indigo-800" aria-hidden />
      <h1 className="text-2xl font-semibold text-indigo-800">
        No access to OpenUp Spaces
      </h1>
      <p className="max-w-md text-gray-600">
        You are signed in as {user.email}, but this account does not have the
        Customer Success role required to manage events. Contact your
        administrator if you believe this is a mistake.
      </p>
      <Button
        variant="default"
        onClick={onSignOut}
        disabled={logoutMutation.isPending}
      >
        Sign out
      </Button>
    </div>
  );
};

export default AccessDenied;
